<template>
    <div v-if="authStore.isAuthenticated">
        <h1>Nurse Activity</h1>
        <v-row justify="center">
            <v-col cols="12" sm="8" md="6" lg="4">
                <v-text-field v-model="authStore.user.studentNum" label="รหัสนักศึกษา" variant="outlined"
                    readonly></v-text-field>
                <v-select v-model="select" label="เลือกกิจกรรม" :items=activity></v-select>
                <div v-if="select === 'Young Simulation'">
                    <v-select v-model="selectDep" label="เลือกภาควิชา" :items=department></v-select>
                </div>
                <v-text-field label="Code for pass" variant="outlined"></v-text-field>
            </v-col>
        </v-row>

    </div>
</template>

<script setup>
import { useAuthStore } from "@/stores/auth";
import { ref, computed, watch, onMounted } from "vue";

const authStore = useAuthStore();
const select = ref("");
const selectDep = ref("");
const activity = ref(["NSLIC Activity", "Young Simulation"]);
const department = ref(["การพยาบาลผู้ใหญ่และผู้สูงอายุ", "การพยาบาลอนามัยชุมชน", "การพยาบาลมารดาทารกและการผดุงครรภ์", "การพยาบาลสุขภาพจิตและจิตเวช", "การพยาบาลเด็กและวัยรุ่น"]);
</script>